import React from 'react';
import { createContainer } from '@dbk-legacy/muster/react';
import { TouchableOpacity } from 'react-native';
import { GenericEdited } from '@dbk/ui-icons';
import { View } from '@dbk/ui-react-utils';
import format from 'date-fns/format';
import { NavigationListItemHeader, NavigationListItemFooter, NavigationListItemContent } from '@dbk/ui-list';
import { Checkbox } from '@dbk/ui-forms';
import Text, { Large } from '@dbk/ui-text';
import { PALETTE } from '../../../constants';
// import styles from './reports.styles';
import { formatDate } from '../report-utils';


const ReportUnreadCategoryListItem = ((props) => {
  const { item, showSeperator, isFirstItem, auth : { langCode, documentPreviewDisabled } } = props;
  const cursorClass = documentPreviewDisabled ? 'notAllowedCursor':'' ;  //WMCE-42437- Switching cursor style to not allowed when preview is disabled for RM
  const receivedDate = formatDate(item.receivedDate, langCode);
  let displayId = '';
  let refCurrency = '';
    if((item.portfolioId && item.bpId) || (item.portfolioId  && !item.bpId)){
        displayId = item.portfolioId;
        refCurrency = item.refCurrency;
    }else if(item.bpId && !item.portfolioId){
        displayId = item.bpId;
        refCurrency = '';
    }
  return (
    <View style={{ marginLeft: 15, width: '95%' }}>
      <View style={[isFirstItem ? { paddingTop: 24, paddingBottom: 14 } : { paddingTop: 24, paddingBottom: 14 }
        , showSeperator ? { borderBottomWidth: 1, borderBottomColor: '#535b61', borderBottomStyle: 'solid' } : {},
      { display: 'flex' }]}>

        <View style={{  paddingTop: 2}}>
          <Checkbox
            style={{ paddingRight: "35px" }}
            name="checkbox"
            className="checkboxClass"
            checked={item.checked}
            onChange={() => props.handleReportItemClick(item)}
            testID="checkbox_report_reportUnreadCategoryListItem_test" />
        </View>
        <View style={{ width: '85%', marginLeft: "5px"}}>
          <View style={{ width: '90%' }}>
            <TouchableOpacity disabled={documentPreviewDisabled}
            onPress={() => props.handlePreviewClick(item)} >
              <Large testID="text_reportDocName_reportUnreadCategoryListItem_test" numberOfLines={1} ellipsizeMode={'tail'} style={[item.read ? { marginRight: 0 } : { marginRight: 0 }, { color: PALETTE.primaryActive }, { overflow: 'hidden' }, { whiteSpace: 'nowrap' }, { textOverflow: 'ellipsis' }, { display: 'block' }]} >
                {item.documentName}
              </Large>
            </TouchableOpacity>
          </View>
          <View style={{
            paddingTop: 10, paddingBottom: 10, width: '90%', height: 40
          }}>
            <View style={{
              width: '50%', color: '#a7a8aa', fontSize: 14,
              display: 'inline', verticalAlign: 'middle'
            }} >
              <Text style={{ color: '#a7a8aa' }} >{(displayId)}</Text>
              <Text style={{ color: '#a7a8aa' }} > {(refCurrency)}</Text>
            </View>
            <View style={{ fontSize: 14, width: '30%', display: 'inline-block', textAlign: 'right', float: 'right', verticalAlign: 'top' }}>
              <Text style={{ color: '#a7a8aa' }} >{receivedDate}</Text>
            </View>
          </View>
        </View>
        <View style={{ flex: 0.1, alignItems: 'center', paddingTop: 8 }}>
          <TouchableOpacity
            testID="icon_reportDocIcon_reportUnreadCategoryListItem_test"
            className={`docPreviewClassSecondary ${cursorClass}`}
            disabled={documentPreviewDisabled}
            onPress={() => props.handlePreviewClick(item)} >
            <GenericEdited color={PALETTE.primaryTextDisabled}
              height={34}
              width={34}
            />
          </TouchableOpacity>
        </View>
      </View>
     </View>


    /* <View className="docflexClass categoryText">
            <View style={{ flex: 0.9}} className="listColumn">
                <NavigationListItemHeader>
                    <Checkbox
                        name="checkbox"
                        checked={item.checked}
                        indeterminate={item.isIndeterminate}
                        className="checkboxClass"
                        onClick={() => props.handleReportItemClick(item)} />

                    <TouchableOpacity onClick={() => props.handlePreviewClick(item)} >
                        <Text className='textArea' numberOfLines={1}
                            ellipsizeMode={'tail'}
                            style={
                                [item.read ? { color: '#ffffff' } : { color: '#ec6b10' },
                                { overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }]}>
                            {item.documentName}
                        </Text>
                    </ TouchableOpacity >
                </NavigationListItemHeader>
                <View className="docflexClassSecondary">
                    <NavigationListItemFooter className="rowFooter" secondary>
                    {(item.portfolioId ? item.portfolioId : '') + ` ` + (item.refCurrency ? item.refCurrency : '')}
                    </NavigationListItemFooter >
                    {(
                        <NavigationListItemContent secondary style={{ right: "20%", marginTop: 5 }}>{format(item.receivedDate, 'DD MMM YY')}</NavigationListItemContent>
                    )}
                </View>
            </View>

            <View style={{
                flex: 0.1,

            }} >
                <TouchableOpacity style={{
                    height: '100%',
                    width: '100%',
                    justifyContent: 'center',
                    flexDirection: 'row',
                    alignItems: 'center'
                }} onClick={() => props.handlePreviewClick(item)} >
                    <PDF color={PALETTE.primaryTextDisabled}
                        height={34}
                        width={34}
                    />
                </ TouchableOpacity >

            </View>

        </View> */
  );
})

export default createContainer(
  {
    $queries: {
      changePage: { $call: 'ui.history.replace' },
      app: {
        global: {
          deviceInfo: {
            isTablet: true
          }
        }
      },
      i18n: {
        messages: true
      },
      auth: {
        langCode: true,
        documentPreviewDisabled: true
    }
    }
  },
  ({ ui, ...queries }) => ({
    ...queries
  })
)(ReportUnreadCategoryListItem);


